import style from "@/styles/pages/AnswerSecurity/AnswerSecurity.module.css";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import { useEffect, useState } from "react";
import {
    clearApplicationState,
    setPromoCode,
} from "@/slices/applicationSlice";
import { clearApplicantState, clearJointState } from "@/slices/applicantSlice";
import { clearAddressState } from "@/slices/homeAddressSlice";
import { clearMailingAddressState } from "@/slices/mailingAddressSlice";
import { clearCredentialState } from "@/slices/credentialSlice";
import { clearProgressState } from "@/slices/progressSlice";
import { clearLegalTermsState } from "@/slices/legalTermsSlice";
import FadeTransition from "@/styles/animation/FadeTransition";
import { clearEmploymentState } from "@/slices/employmentSlice";
import { clearPreviousEmploymentState } from "@/slices/previousEmploymentSlice";
import { clearSessionState } from "@/slices/sessionDataSlice";
import { clearAssetState } from "@/slices/assetSlice";
import { clearExpenseState } from "@/slices/expenseSlice";

export default function Logout() {
    const client = createApiClient({ timeout: 60000 });
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [passwordShown, setPasswordShown] = useState(false);

    // Get Query Parameters (productIds)
    let productIds = "";
    let promoCode = "";

    useEffect(() => {

        productIds = (searchParams.get("productIds") != null) ? decodeURIComponent(searchParams.get("productIds") + "") : "";
        promoCode = (searchParams.get("prm") != null) ? (searchParams.get("prm") + "") : "";

        dispatch(clearSessionState());
        dispatch(clearCredentialState());
        dispatch(clearApplicationState());
        dispatch(clearApplicantState());
        dispatch(clearEmploymentState());
        dispatch(clearAssetState());
        dispatch(clearExpenseState());
        dispatch(clearPreviousEmploymentState());
        dispatch(clearAddressState());
        dispatch(clearMailingAddressState());
        dispatch(clearProgressState());
        dispatch(clearLegalTermsState());
        dispatch(clearJointState());
        dispatch(setPromoCode(promoCode));
    }, []);

    const handleClick = () => {
        navigate("/login");
    }

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    return (
        <FadeTransition>
            <main aria-labelledby="main-content">
                <div className="main-container max-md:mt-10">
                    <div className={clsx(style.login, "container", "mt-10")}>
                        <div className={style.emHeading}>
                            <div className="grid grid-cols-1">
                                <h1>You have successfully signed out</h1>
                            </div>
                        </div>
                        <div className="flex relative">
                            <button
                                onClick={handleClick}
                                className="primary mt-5 w-full sm:w-28 h-11 px-6">
                                Sign in again
                            </button>
                        </div>
                        <div className="flex relative">
                            <button
                                onClick={handleClick}
                                className={clsx("secondary mt-5 w-full sm:w-28 h-11 px-6", style.secondary)}>
                                Return to meridiancu.ca
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </FadeTransition>
    );
}
